import classNames from "classnames";
import {
  Action,
  Container,
  Heading5,
  Heading6,
  Icon,
  ImageLite,
  ModalWrapper,
  Paragraph,
  YoutubeVideo,
} from "shared/components";
import { useToggle } from "shared/hooks";
import { parseYouTubeId } from "shared/utils";

import styles from "./Content083.module.scss";

export const Content083 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const position = payload?.position ?? "left";
  const { fullName, labelText, role } = payload?.person ?? {};
  const image = payload?.person?.preview ?? {};
  const { buttonText, videoLink } = payload?.button ?? {};

  const videoId = parseYouTubeId(videoLink);

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={classNames(styles.block, styles[position])}>
          <div className={styles.content}>
            <div>
              <Heading5 className={styles.title} color="brand">
                {title}
              </Heading5>
              <Heading6 className={styles.description} color="dark">
                {description}
              </Heading6>
            </div>
            <div className={styles.person}>
              <ImageLite image={image} className={styles.image} />
              <div>
                <div className={styles["person-details"]}>
                  <Paragraph
                    color="dark"
                    appearance="bigger"
                    className={styles.name}
                  >
                    {fullName}
                  </Paragraph>
                  {labelText && (
                    <Paragraph
                      color="light"
                      appearance="bigger"
                      className={styles.label}
                    >
                      {labelText}
                    </Paragraph>
                  )}
                </div>

                <Paragraph color="grey" className={styles.role}>
                  {role}
                </Paragraph>
              </div>
            </div>
          </div>
          <div className={styles.action}>
            <Action
              onClick={onOpen}
              className={styles.button}
              disabled={!videoId}
            >
              <span className={styles.play}>
                <Icon className={styles.icon} name="play" theme="white" />
              </span>
              <Paragraph
                color="brand"
                appearance="bigger"
                className={styles["button-text"]}
              >
                {buttonText}
              </Paragraph>
            </Action>
            {opened && (
              <ModalWrapper onCloseModal={onClose} appearance="full-area">
                <YoutubeVideo id={videoId} />
              </ModalWrapper>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content083;
